var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#Rectangle-2_5_);}\r\n\t.st1{fill:url(#Rectangle-2_6_);}\r\n\t.st2{fill:url(#Rectangle-2_7_);}\r\n\t.st3{fill:url(#Rectangle-2_8_);}\r\n\t.st4{fill:url(#Rectangle-2_9_);}\r\n\t.st5{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Types_Poison",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6667,
    y1: 61.5333,
    x2: 10.6667,
    y2: 61.5333,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A864C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C261D4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2_1_",
    className: "st0",
    d: "M36,0L36,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Types_Psychic",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.4667,
    y1: 60.3333,
    x2: 9.4667,
    y2: 60.3333,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F66F71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE9F92"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2_4_",
    className: "st1",
    d: "M0,36L0,36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6667,
    y1: 59.1333,
    x2: 10.6667,
    y2: 59.1333,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F66F71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE9F92"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2_3_",
    className: "st2",
    d: "M36,72L36,72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6667,
    y1: 61.5333,
    x2: 10.6667,
    y2: 61.5333,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F66F71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE9F92"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2_2_",
    className: "st3",
    d: "M36,0L36,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Types_Rock",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6667,
    y1: 61.5333,
    x2: 10.6667,
    y2: 59.1333,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5B489"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7CD90"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st4",
    d: "M36,0L36,0c19.9,0,36,16.1,36,36l0,0c0,19.9-16.1,36-36,36l0,0C16.1,72,0,55.9,0,36l0,0 C0,16.1,16.1,0,36,0z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    className: "st5",
    d: "M22.4,35.3l-7.8-2.6l13.6-9.3c0.2-0.1,0.5-0.1,0.6,0.1c0,0,0,0,0,0l3.1,4.6 c0.1,0.2,0.1,0.5-0.1,0.6l-9,6.5c-0.1,0.1-0.2,0.1-0.3,0.1C22.5,35.4,22.4,35.3,22.4,35.3z M11.3,32.1l-6.8-2.2 c-0.2-0.1-0.3-0.2-0.3-0.4v-7c0-0.1,0-0.2,0.1-0.3L15,9.2c0.1-0.1,0.2-0.2,0.3-0.2h13.8c0.2,0,0.4,0.2,0.4,0.4c0,0,0,0,0,0.1 l-1.7,11.1c0,0.1-0.1,0.2-0.2,0.3L11.7,32c-0.1,0-0.2,0.1-0.2,0.1C11.4,32.1,11.4,32.1,11.3,32.1L11.3,32.1z M34,26.7l-3.7-5.1 c-0.1-0.1-0.1-0.2-0.1-0.3l2-11.9c0-0.2,0.2-0.4,0.4-0.4l0,0c0.2,0,0.4,0.1,0.4,0.3L37.7,24c0.1,0.2,0,0.4-0.1,0.5l-3,2.3 C34.4,26.9,34.1,26.9,34,26.7C34,26.7,34,26.7,34,26.7L34,26.7z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRock);
export default __webpack_public_path__ + "static/media/rock.92df6dc0df3699c393f4f57a7c3f3b02.svg";
export { ForwardRef as ReactComponent };